import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../utils/rel';

class NewsSiderContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        isVideo: PropTypes.bool,
        hasTopic: PropTypes.bool,
        hasSummary: PropTypes.bool,
    };

    render() {
        const { content, isVideo, hasTopic, hasSummary } = this.props;

        return (
            <dl className={styles.list}>
                {content.map((item, index) => (
                    <React.Fragment key={index}>
                        <dt className={`${isVideo ? styles.video : ''} ${index === 0 && hasTopic ? styles.topic : ''}`}>
                            {item.children && item.children.length > 0 ? (
                                <React.Fragment>
                                    <a href={item.url} target="_blank" rel={rel}>
                                        {item.title}
                                    </a>
                                    {item.children.map((item, index) => (
                                        <a key={index} href={item.url} target="_blank" rel={rel}>
                                            {item.title}
                                        </a>
                                    ))}
                                </React.Fragment>
                            ) : (
                                <a href={item.url} target="_blank" rel={rel}>
                                    {item.title}
                                </a>
                            )}
                        </dt>
                        {hasTopic && item.thumbnail && item.thumbnail !== '' && item.summary && item.summary !== '' ? (
                            <dd className={styles.pic_box}>
                                <div className={styles.pic}>
                                    <a href={item.url} target="_blank" rel={rel} data-nomask>
                                        <img src={item.thumbnail} />
                                    </a>
                                </div>
                                <span>{item.summary}</span>
                            </dd>
                        ) : (
                            ''
                        )}
                        {(hasTopic &&
                            (!item.thumbnail || item.thumbnail === '') &&
                            item.summary &&
                            item.summary !== '') ||
                        (hasSummary && item.summary && item.summary !== '') ? (
                            <dd>{item.summary}</dd>
                        ) : (
                            ''
                        )}
                    </React.Fragment>
                ))}
            </dl>
        );
    }
}

export default errorBoundary(NewsSiderContent);
